import { put, call, takeLatest, all } from 'redux-saga/effects';
import Bugsnag from '@bugsnag/js';
import { processRequest } from '../../../services/Api';
import { lessonDetailsActionTypes } from './Constants';
import { processTutoringRequest } from '../../shared/Constants';
import * as lessonActions from './Actions';
import * as errorHandlerActions from '../../../components/errorHandler/Actions';

export default function* () {
	yield all([
		yield takeLatest(
			lessonDetailsActionTypes.GET_SINGLE_LESSON_DETAILS_REQUEST,
			handleLessonDetailsAndScheduleRequest,
		),
		yield takeLatest(
			lessonDetailsActionTypes.GET_SCHEDULE_LESSONS_REQUEST,
			handleScheduleLessonsRequest,
		),
		yield takeLatest(
			lessonDetailsActionTypes.DELETE_SCHEDULED_LESSON_REQUEST,
			handleDeleteScheduledLessonRequest,
		),
	]);
}

export function* handleLessonDetailsAndScheduleRequest({ payload }) {
	try {
		const { lessonId } = payload || {};

		const { data } = yield call(processTutoringRequest, `public/lessons/${lessonId}`, 'GET');
		const { lesson, no_index } = data || {};

		yield put(
			lessonActions.getLessonDetailsSuccess({ data: lesson, no_index, loading: false }),
		);

		const { chapter_ids } = lesson || {};

		if (chapter_ids?.length) {
			const { data: topics } = yield call(
				processRequest,
				`public/topics?chapter_ids=${chapter_ids.join(',')}`,
			);
			yield put(
				lessonActions.getLessonDetailsSuccess({
					topics,
					data: lesson,
					loadingTopics: false,
				}),
			);
		}
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(lessonActions.getLessonDetailsError());
	}
}

export function* handleScheduleLessonsRequest({ payload }) {
	try {
		const { lessonId } = payload || {};

		const { data } = yield call(processTutoringRequest, 'public/scheduled_lessons', 'GET', {
			scheduled_lessons: {
				lesson_id: lessonId,
			},
		});

		const invalidNoScheduledLessonsResponse =
			data === undefined ||
			data === null ||
			data === '' ||
			data === 0 ||
			data === false ||
			data == {} ||
			data === NaN;

		if (invalidNoScheduledLessonsResponse) {
			Bugsnag.notify(new Error('Invalid response from scheduled_lessons endpoint'));
			return yield put(lessonActions.getScheduledLessonsSuccess([]));
		}
		yield put(lessonActions.getScheduledLessonsSuccess(data ?? []));
		const isUserSignedUp = !!data?.length
			? data?.some((item) => item.scheduled_lesson_user_id)
			: false;
		yield put(lessonActions.setSignedUp(isUserSignedUp));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(lessonActions.getScheduledLessonsError());
	}
}

export function* handleDeleteScheduledLessonRequest({ payload }) {
	try {
		const {
			data: { scheduledLessonUserId, callback },
		} = payload || {};
		yield call(
			processTutoringRequest,
			`scheduled_lesson_users/${scheduledLessonUserId}`,
			'DELETE',
		);
		yield put(lessonActions.deleteScheduledLessonSuccess());
		yield put(lessonActions.setSignedUp(false));

		if (callback) callback();
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(lessonActions.deleteScheduledLessonError());
	}
}
